import { Box } from "@chakra-ui/react";
import { DatePicker } from "@material-ui/pickers";
import React from 'react';
import"../sass/calendario.scss"

export default function Calendario(props) {
    return (
        <>
            <Box>
                <div className="top-card">
                    Dias disponíveis
                </div>
                <Box pt={'1px'}>
                    <DatePicker
                        variant="static"
                        label={"Calendario"}
                        disabled={props.disableForm}
                        value={props.date}
                        onChange={(e) => props.change(e)}
                        maxDate={new Date(2100, 12, 30)}
                        disablePast={true}
                        shouldDisableDate={props.disable}
                        onMonthChange={(date) => props.onMonthChange(date)}
                    />
                </Box>
            </Box>
        </>
    )
}